<template>
  <div class="home-container">
    <div class="home-content">
      <!-- 搜索 -->
      <div>
        <el-form :model="searchForm" ref="searchForm" label-width="80px">
          <el-row>
            <el-col :span="6">
              <el-form-item
                label="派单人员"
                prop="name"
                label-width="100px"
                style="width: 80%"
              >
                <el-select
                  clearable filterable
                  v-model="searchForm.manageUserId"
                  placeholder="请选择派单人员"
                >
                  <el-option
                    v-for="item in personList"
                    :key="item.id"
                    :label="item.userName"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-button
                size="small"
                @click="onLoad(1)"
                type="primary"
                icon="el-icon-search"
                style="width: 90px"
                >搜索</el-button
              >
              <el-button
                size="small"
                @click="restSearch"
                type="danger"
                style="width: 90px"
                >重置</el-button
              >
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div style="margin: 20px">
        <el-button
          size="small"
          plain
          type="primary"
          icon="el-icon-plus"
          @click="addCharacter"
          style="width: 90px"
          >新增</el-button
        >
      </div>

      <el-table
        border
        :data="tableData"
        v-loading="isShowloading"
        style="width: 100%"
      >
        <el-table-column prop="content" label="派单内容" align="center">
        </el-table-column>
        <el-table-column prop="dispatchTime" label="派单时间" align="center" :formatter="desttibuteTimeList">
        </el-table-column>
        <el-table-column
          prop="timeType"
          label="时间类型"
          align="center"
          :formatter="timeTypeList"
        >
        </el-table-column>
        <el-table-column fixed="right" align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="updataCharacter(scope.row)"
              >修改</el-button
            >

            <el-button @click="del(scope.row)" type="text" size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
      <!-- 新增模态框 -->
      <el-dialog :title="modalTitle" :visible.sync="isAddModal" width="50%">
        <el-form
          ref="form"
          :model="addData"
          label-width="90px"
          :rules="addDataRules"
          label-position="center"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="时间类型" prop="time">
                <el-select
                  clearable filterable
                  v-model="addData.timeType"
                  @change="timeChange"
                  placeholder="请选择时间类型"
                >
                  <el-option label="常规时间" :value="0"> </el-option>
                  <el-option label="每周时间" :value="1"> </el-option>
                  <el-option label="每月时间" :value="2"> </el-option>
                  <el-option label="每年时间" :value="3"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                v-if="addData.timeType != 1"
                label="巡更日期"
                prop="dispatchTime"
              >
                <el-date-picker
                  v-model="addData.dispatchTime"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="选择巡更日期"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item
                v-if="addData.timeType == 1"
                label="巡更日期"
                prop="dispatchTime"
              >
                <el-select
                  clearable filterable
                  v-model="addData.dispatchTime"
                  multiple
                  placeholder="选择巡更日期"
                >
                  <el-option
                    v-for="item in timeList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="人员类型" prop="manageUserClassId">
                <el-select
                  clearable filterable
                  v-model="addData.manageUserClassId"
                  @change="manageChange"
                  placeholder="请选择人员类型"
                >
                  <el-option
                    v-for="item in personClassList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="物业人员" prop="manageUserId">
                <el-select
                  clearable filterable
                  v-model="addData.manageUserId"
                  placeholder="请选择物业人员"
                >
                  <el-option
                    v-for="item in personList"
                    :key="item.id"
                    :label="item.userName"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="派单类型" prop="dispatchOrderCategoryId">
                <el-select
                  clearable filterable
                  v-model="addData.dispatchOrderCategoryId"
                  placeholder="请选择派单类型"
                >
                  <el-option
                    v-for="item in nightPatrolList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="派单内容" prop="content">
                <el-input
                  placeholder="请输入派单内容"
                  type="textarea"
                  :rows="3"
                  v-model="addData.content"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isAddModal = false">取 消</el-button>
          <el-button type="primary" @click="submit" :loading="btnLoading"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import reg from "@/utils/reg";
export default {
  data() {
    return {
      searchForm: {
        manageUserId: "",
        patrolTime: "",
      },
      checkedStr: [], //选中的名称
      checkedIds: [], //选中的id
      isShowTrue: false, //是否显示二级树
      defaultProps: {
        children: "children",
        value: "id",
        label: "name",
      },
      houseFlag: true,
      modalTitle: "新增",
      props: {
        multiple: true,
        value: "id",
        label: "name",
        checkStrictly: true,
      },
      muneListData: [], //菜单信息
      tableData: [],
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10, // 每页的数据条数
      nightPatrolList: [],
      addData: {
        id: "",
        timeType: "",
        dispatchTime: "",
        dispatchzTime: "",
        manageUserClassId: "",
        manageUserId: "",
        dispatchOrderCategoryId: "",
        content: "",
      },
      timeList: [
        {
          id: 1,
          name: "周一",
        },
        {
          id: 2,
          name: "周二",
        },
        {
          id: 3,
          name: "周三",
        },
        {
          id: 4,
          name: "周四",
        },
        {
          id: 5,
          name: "周五",
        },
        {
          id: 6,
          name: "周六",
        },
        {
          id: 7,
          name: "周日",
        },
      ],
      addDataRules: {
        timeType: [
          { required: true, message: "请选择时间类型", trigger: "blur" },
        ],
        dispatchOrderCategoryId: [
          { required: true, message: "请选择派单类型", trigger: "blur" },
        ],        
        dispatchTime: [
          { required: true, message: "请输入派单日期", trigger: "blur" },
        ],
        content: [
          { required: true, message: "请输入派单内容", trigger: "blur" },
        ],
        manageUserId: [
          { required: true, message: "请选择物业人员", trigger: "blur" },
        ],
      },
      patrolClass: [],
      personList: [],
      personClassList: [],
      isShowloading: false, //数据加载
      isAddModal: false, //新增模态框
      btnLoading: false, //提交按钮加载
    };
  },
  created() {},
  mounted() {
    this.onLoad();
  },
  methods: {
    desttibuteTimeList(row) {
      if(row.timeType == 0){
        return row.dispatchTime
      }else{
        let str = []
        this.timeList.forEach(res=>{
          row.dispatchTime.forEach(item=>{
            if(res.id == item){
              str.push(res.name)
            }
          })
        })
        return str.join(',')
      }
    },
    timeChange(e) {
      if (e == 0) {
        this.addData.dispatchTime = "";
      } else {
        this.addData.dispatchzTime = "";
      }
    },
    manageChange(e) {
      this.addData.manageUserId = "";
      this.manageList(e);
    },
    manageList(e) {
      let data = {
        manageUserTypeId: e || "",
      };
      this.$Apis.manageTotalList(data).then((res) => {
        if (res.code == 200) {
          let list = res.data.filter(item=>item.userType == 2)
          this.personList = list;
        }
      });
    },
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },
    // 新增角色
    addCharacter() {
      for (let item in this.addData) {
        this.addData[item] = "";
      }
      this.addData.timeType = 0;
      this.modalTitle = "新增";
      this.isAddModal = true;
    },
    // 修改角色
    updataCharacter(row) {
      this.addData = JSON.parse(JSON.stringify(row));
      this.$Apis.manageTotalList().then((res) => {
        if (res.code == 200) {
          this.addData.manageUserClassId = res.data.filter(
            (res) => res.id == this.addData.manageUserId
          )[0].manageUserTypeId;
          this.isAddModal = true;
        }
      });
    },
    //删除角色
    del(row) {
      let id = row.id;
      this.$confirm("您确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$Apis.dispatchOrderDel({ id }).then((res) => {
          if (res.code == 200) {
            this.onLoad();
            this.$message.success("删除成功");
          } else {
            this.$message.warning(res.msg);
          }
        });
      });
    },
    timeTypeList(row) {
      if(row.timeType == 0){
        return "固定时间"
      }else if(row.timeType == 1){
        return "每周时间"
      }else if(row.timeType == 2){
        return "每月时间"
      }else if(row.timeType == 3){
        return "每年时间"
      }
    },
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let dispatchTime = "";
          if (this.addData.timeType == 0) {
            dispatchTime = this.addData.dispatchTime;
          } else {
            dispatchTime = this.addData.dispatchTime.join(",");
          }
          this.btnLoading = true;
          var data = {
            id: this.addData.id || "",
            timeType: this.addData.timeType,
            manageUserId: this.addData.manageUserId,
            dispatchTime,
            dispatchOrderCategoryId: this.addData.dispatchOrderCategoryId,
            content: this.addData.content,
          };
          this.$Apis.dispatchOrderAddUp(data).then((res) => {
            this.btnLoading = false;
            this.isAddModal = false;
            if (res.code == 200) {
              this.onLoad();
              this.$message.success("操作成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        }
      });
    },

    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad();
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad();
    },
    onLoad(ind) {
      this.manageList();
      this.$Apis.manageTypeAllList().then((res) => {
        if (res.code == 200) {
          this.personClassList = res.data;
        }
      });
      this.$Apis.dispatchOrderClassAllList().then((res) => {
        if (res.code == 200) {
          this.nightPatrolList = res.data;
        }
      });
      this.isShowloading = true;
      if(ind == 1){
        this.currentPage = 1
      }
      let page = {
        size: this.pageSize,
        current: this.currentPage,
        manageUserId: this.searchForm.manageUserId,
      };
      this.$Apis.dispatchOrderList(page).then((res) => {
        this.isShowloading = false;
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          list.forEach((item, ind) => {
            item.ind = ind + 1;
            if(item.timeType == 1){
              item.dispatchTime = item.dispatchTime.split(',').map(res=>Number(res))
            }
          });
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
        }
      });
    },
  },
};
</script>

<style>
.home-container {
  padding: 10px;
  padding-top: 5px;
}
.home-content {
  padding: 10px;
  border-radius: 5px;
  background: #fff;
}
.tree {
  margin-top: 10px;
  width: 300px;
  z-index: 999;
  background-color: #fff;
  padding: 20px;
  height: 200px;
  overflow: auto;
  border: 1px solid #eee;
  border-radius: 5px;
}
</style>